<template>
  <div class="mountain-page">
    <div class="audio-box" @click="controlMusic">
      <img
        v-show="qtAudioPlaying"
        class="audio-on"
        src="../assets/img/music_on.png"
        alt=""
      />
      <img
        v-show="!qtAudioPlaying"
        class="audio-off"
        src="../assets/img/music_off.png"
        alt=""
      />
    </div>

    <div v-show="!visitedAll" @click="hideRoad" class="back-btn" alt="">
      <img
        class="back-btn-txt abs"
        src="../assets/img/back_btn_txt.png"
        alt=""
      />
    </div>
    <img
      v-show="!visitedAll"
      @click="endVisit"
      class="end-btn"
      src="../assets/img/end_btn.png"
      alt=""
    />
    <div class="end-page abs">
      <div class="end-txt abs"></div>
      <!-- <img class="end-txt abs" src="../assets/img/end_txt_qt.png" alt="" /> -->
      <img class="end-page-bg" src="../assets/img/end_page_qt.jpg" alt="" />
    </div>

    <div class="mountain">
      <div class="progress-list-box abs">
        <img class="icon-road abs" src="../assets/img/icon_road1.png" alt="" />
        <div
          :class="[actIndex == item ? 'active' : '', 'progress-item']"
          v-for="item in 9"
          :key="item"
        ></div>
      </div>
      <!-- 淳安县 -->
      <img
        class="nor-ca-moun1 abs"
        src="../assets/img/nor_wy_moun1.png"
        alt=""
      />
      <div class="moun-box-ca abs">
        <img class="data-moun-ca" src="../assets/img/data_moun_ca.png" alt="" />
        <div class="data-box-ca abs"></div>
      </div>
      <img class="address-ca abs" src="../assets/img/address_ca.png" alt="" />

      <!-- <img class="feature-ca abs" src="../assets/img/feature_ca.jpg" alt="" /> -->
      <div class="feature-ca abs">
        <img
          ref="featureCaGif"
          class="feature-data abs"
          src="../assets/img/feature_ca.gif"
          alt=""
        />
        <img
          class="feature-bg"
          style="width:100%; height: 100%;"
          src="../assets/img/feature_ca_bg.png"
          alt=""
        />
      </div>
      <img class="product-ca abs" src="../assets/img/product_ca.png" alt="" />
      <!-- <div class="product-ca abs"></div> -->
      <!-- 淳安县 -->

      <!-- 武义县 -->
      <img
        class="nor-wy-moun1 abs"
        src="../assets/img/nor_wy_moun1.png"
        alt=""
      />
      <div class="moun-box-wy abs">
        <img class="data-moun-wy" src="../assets/img/data_moun_wy.png" alt="" />
        <div class="data-box-wy abs"></div>
      </div>
      <img class="address-wy abs" src="../assets/img/address_wy.png" alt="" />

      <!-- <img class="feature-wy abs" src="../assets/img/feature_wy.jpg" alt="" /> -->
      <div class="feature-wy abs">
        <img
          ref="featureWyGif"
          class="feature-data abs"
          src="../assets/img/feature_wy.gif"
          alt=""
        />
        <img
          class="feature-bg"
          style="width:100%; height: 100%;"
          src="../assets/img/feature_wy_bg.png"
          alt=""
        />
      </div>
      <img class="product-wy abs" src="../assets/img/product_wy.png" alt="" />
      <!-- <div class="product-wy abs"></div> -->
      <!-- 武义县 -->

      <!-- 磐安县 -->
      <img
        class="nor-pa-moun1 abs"
        src="../assets/img/nor_pa_moun1.png"
        alt=""
      />
      <div class="moun-box-pa abs">
        <img class="data-moun-pa" src="../assets/img/data_moun_pa.png" alt="" />
        <div class="data-box-pa abs"></div>
      </div>
      <img class="address-pa abs" src="../assets/img/address_pa.png" alt="" />
      <!-- 磐安县 -->

      <!-- 龙游县 -->
      <img
        class="nor-ly-moun1 abs"
        src="../assets/img/nor_ly_moun1.png"
        alt=""
      />
      <div class="moun-box-ly abs">
        <img class="data-moun-ly" src="../assets/img/data_moun_ly.png" alt="" />
        <div class="data-box-ly abs"></div>
      </div>
      <img class="address-ly abs" src="../assets/img/address_ly.png" alt="" />

      <!-- <img class="feature-ly abs" src="../assets/img/feature_ly.jpg" alt="" /> -->
      <div class="feature-ly abs">
        <img
          ref="featureLyGif"
          class="feature-data abs"
          src="../assets/img/feature_ly.gif"
          alt=""
        />
        <img
          class="feature-bg"
          style="width:100%; height: 100%;"
          src="../assets/img/feature_ly_bg.png"
          alt=""
        />
      </div>
      <img class="product-ly abs" src="../assets/img/product_ly.png" alt="" />
      <!-- <div class="product-ly abs"></div> -->
      <!-- 龙游县 -->

      <!-- 衢江区 -->
      <img
        class="nor-qj-moun1 abs"
        src="../assets/img/nor_qj_moun1.png"
        alt=""
      />
      <div class="moun-box-qj abs">
        <img class="data-moun-qj" src="../assets/img/data_moun_qj.png" alt="" />
        <div class="data-box-qj abs"></div>
      </div>
      <img class="address-qj abs" src="../assets/img/address_qj.png" alt="" />
      <!-- 衢江区 -->

      <!-- 柯城区 -->
      <img
        class="nor-kc-moun2 abs"
        src="../assets/img/nor_kc_moun2.png"
        alt=""
      />
      <img
        class="nor-kc-moun1 abs"
        src="../assets/img/nor_kc_moun1.png"
        alt=""
      />
      <div class="moun-box-kc abs">
        <img class="data-moun-kc" src="../assets/img/data_moun_kc.png" alt="" />
        <div class="data-box-kc abs"></div>
      </div>
      <img class="address-kc abs" src="../assets/img/address_kc.png" alt="" />
      <!-- 柯城区 -->

      <!-- 开化县 -->
      <img
        class="nor-kh-moun1 abs"
        src="../assets/img/nor_kh_moun1.png"
        alt=""
      />
      <div class="moun-box-kh abs">
        <img class="data-moun-kh" src="../assets/img/data_moun_kh.png" alt="" />
        <div class="data-box-kh abs"></div>
      </div>
      <img class="address-kh abs" src="../assets/img/address_kh.png" alt="" />

      <!-- <img class="yao abs" src="../assets/img/yao.gif" alt="" /> -->
      <!-- 开化县 -->

      <!-- 常山县 -->
      <img
        class="nor-cs-moun1 abs"
        src="../assets/img/nor_cs_moun1.png"
        alt=""
      />
      <div class="moun-box-cs abs">
        <img class="data-moun-cs" src="../assets/img/data_moun_cs.png" alt="" />
        <div class="data-box-cs abs"></div>
      </div>
      <img class="address-cs abs" src="../assets/img/address_cs.png" alt="" />

      <!-- <img class="feature-cs abs" src="../assets/img/feature_cs.jpg" alt="" /> -->
      <div class="feature-cs abs">
        <img
          ref="featureCsGif"
          class="feature-data abs"
          src="../assets/img/feature_cs.gif"
          alt=""
        />
        <img
          class="feature-bg"
          style="width:100%; height: 100%;"
          src="../assets/img/feature_cs_bg.png"
          alt=""
        />
      </div>
      <img class="product-cs abs" src="../assets/img/product_cs.png" alt="" />
      <!-- <div class="product-cs abs"></div> -->
      <!-- 常山县 -->

      <!-- 江山市 -->
      <img
        class="nor-js-moun1 abs"
        src="../assets/img/nor_js_moun1.png"
        alt=""
      />
      <div class="moun-box-js abs">
        <img class="data-moun-js" src="../assets/img/data_moun_js.png" alt="" />
        <div class="data-box-js abs"></div>
      </div>
      <img class="icon-gdp abs" src="../assets/img/icon_gdp_js.png" alt="" />
      <img class="address-js abs" src="../assets/img/address_js.png" alt="" />
      <!-- 江山市 -->
    </div>
    <div class="scroll-page" id="scrollPageQt">
      <div class="inner-scroll"></div>
    </div>
    <img ref="hand" class="hand abs" src="../assets/img/hand.png" alt="" />
    <img
      ref="handTips"
      class="hand-tips abs"
      src="../assets/img/hand_tips.png"
      alt=""
    />
    <!-- <img
      v-if="showCover"
      class="cover-qt"
      id="coverQt"
      src="../assets/img/cover_qt.jpg"
      alt=""
    /> -->
  </div>
</template>
<script>
import gsap from "gsap";
import { Howl } from "howler";
export default {
  name: "Mountain",
  props: ["visitedAll", "qtAudioPlaying"],
  data() {
    return {
      showCover: true,
      actIndex: 1
    };
  },
  created() {
    this.scrollAudio = new Howl({
      src:
        "https://hw-v.cztv.com/cztv/vod/2022/07/26/83a88af31cb145f1b6d2625b2040f7e4/mp3_64k_mp3.mp3",
      preload: true,
      autoplay: false,
      loop: false
    });
    this.featureAudio = new Howl({
      src:
        "https://hw-v.cztv.com/cztv/vod/2022/07/26/7d2da5535fab4bf39043077881ec1e36/mp3_64k_mp3.mp3",
      preload: true,
      autoplay: false,
      loop: false
    });
  },
  mounted() {
    // document.getElementById("coverQt").addEventListener("touchmove", () => {
    //   this.showCover = false;
    // });
    gsap.to(".mountain-page .hand", { y: -50, duration: 2, repeat: -1 });
    document
      .getElementById("scrollPageQt")
      .addEventListener("touchstart", () => {
        this.$refs.hand.style.display = "none";
        this.$refs.handTips.style.display = "none";
        // this.scrollAudio.play();
        gsap.to(".data-box-js", {
          width: "100%",
          duration: 1,
          ease: "Power0.easeIn"
        });
      });

    const tl = new gsap.timeline({
      paused: true
    });

    // tl.to(".data-box-js", { width: "100%", duration: 1, ease: "Power0.easeIn" })
    tl.addLabel("js")
      .to(
        ".moun-box-js",
        {
          x: 50,
          y: 550,
          scale: 1.7,
          duration: 1.5,
          ease: "Power0.easeIn"
        },
        "js+=0.5"
      )
      .to(
        ".nor-js-moun1",
        { x: -80, y: 500, scale: 1.5, duration: 2 },
        "js+=0.5"
      )
      .to(".moun-box-cs", { bottom: 0, opacity: 1, duration: 1 }, "js+=0.5")
      .to(".nor-cs-moun1", { bottom: 0, opacity: 1, duration: 1 }, "js+=0.5")
      // .to(".data-box-js", { opacity: 0, duration: 0.2 }, "js+=0.55")
      .to(".moun-box-kh", { opacity: 0.1, duration: 0.5 }, "js+=0.6")
      .to(".address-js", { x: -50, opacity: 0, duration: 0.5 }, "js+=1")
      .to(
        ".address-cs",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-cs", { width: "100%", duration: 1 });
          }
        },
        "js+=1.2"
      )
      .to(
        [".moun-box-js", ".nor-js-moun1"],
        { opacity: 0, duration: 0.3 },
        "js+=1.4"
      )
      // .to(".data-box-cs", { width: "100%", duration: 1 }, 2.6)
      .addLabel("cs")

      .from(
        ".product-cs",
        {
          opacity: 0,
          width: 0,
          duration: 0.2,
          onStart: () => {
            this.featureAudio.play();
          }
        },
        "cs-=0.5"
      )
      .to(".product-cs", { opacity: 0, duration: 0.2 }, "cs")
      .from(
        ".feature-cs",
        {
          opacity: 0,
          y: 200,
          onStart: () => {
            this.$refs.featureCsGif.style.display = "block";
          }
        },
        "cs"
      )
      .to(".feature-cs", { opacity: 0, y: -200 }, "cs+=0.9")

      .to(".moun-box-kc", { opacity: 0.1, duration: 0.5 }, "cs+=0.3")

      .to(
        ".moun-box-cs",
        {
          x: 50,
          y: 550,
          scale: 1.5,
          duration: 1.5
        },
        "cs+=1.5"
      )
      .to(
        ".nor-cs-moun1",
        { x: -80, y: 530, scale: 1.5, duration: 2 },
        "cs+=1.5"
      )
      .to(".moun-box-kh", { opacity: 1, duration: 0.4 }, "cs+=1.5")
      .to(".moun-box-kh", { bottom: 0, duration: 1 }, "cs+=1.5")
      .to(".nor-kh-moun1", { opacity: 1, duration: 0.3 }, "cs+=1.5")
      .to(".nor-kh-moun1", { y: 50, duration: 1 }, "cs+=1.5")
      .to(".address-cs", { x: -100, opacity: 0, duration: 0.5 }, "cs+=1.9")
      .to(
        ".address-kh",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-kh", { width: "100%", duration: 1 });
          }
        },
        "cs+=2.2"
      )
      .to(
        [".moun-box-cs", ".nor-cs-moun1"],
        { opacity: 0, duration: 0.3 },
        "cs+=2.4"
      )
      // .to(".data-box-kh", { width: "100%", duration: 1 }, 5.2)
      .addLabel("kh")

      .to(".moun-box-qj", { opacity: 0.1, duration: 0.5 }, "kh-=0.2")
      .to(".moun-box-kh", { x: 50, y: 550, scale: 1.5, duration: 1.5 }, "kh")
      .to(".nor-kh-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "kh")
      .to(".moun-box-kc", { opacity: 1, duration: 0.4 }, "kh")
      .to(".moun-box-kc", { bottom: 0, duration: 1 }, "kh")
      .to(".nor-kc-moun1", { opacity: 1, duration: 0.3 }, "kh")
      .to(".nor-kc-moun1", { y: 50, duration: 1 }, "kh")
      .to(".nor-kc-moun2", { opacity: 1, duration: 0.3 }, "kh")
      .to(".nor-kc-moun2", { y: 50, duration: 1 }, "kh")
      .to(
        ".address-kh",
        {
          x: -100,
          opacity: 0,
          duration: 0.5
        },
        "kh+=0.4"
      )
      .to(
        ".address-kc",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-kc", { width: "100%", duration: 1 });
          }
        },
        "kh+=0.6"
      )
      .to(
        [".moun-box-kh", ".nor-kh-moun1"],
        { opacity: 0, duration: 0.3 },
        "kh+=0.9"
      )
      // .to(".data-box-kc", { width: "100%", duration: 1 }, 6.8)
      .addLabel("kc")

      .to(".moun-box-ly", { opacity: 0.1, duration: 0.5 }, "kc-=0.2")
      .to(".moun-box-kc", { x: 50, y: 550, scale: 1.5, duration: 1.5 }, "kc")
      .to(".nor-kc-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "kc")
      .to(".nor-kc-moun2", { x: -80, y: 530, scale: 1.5, duration: 2.5 }, "kc")
      .to(".moun-box-qj", { opacity: 1, duration: 0.4 }, "kc")
      .to(".moun-box-qj", { bottom: 0, duration: 1 }, "kc")
      .to(".nor-qj-moun1", { opacity: 1, duration: 0.3 }, "kc")
      .to(".nor-qj-moun1", { y: 50, duration: 1 }, "kc")
      .to(".address-kc", { x: -100, opacity: 0, duration: 0.5 }, "kc+=0.4")
      .to(
        ".address-qj",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-qj", { width: "100%", duration: 1 });
          }
        },
        "kc+=0.6"
      )
      .to(
        [".moun-box-kc", ".nor-kc-moun1", ".nor-kc-moun2"],
        { opacity: 0, duration: 0.3 },
        "kc+=0.9"
      )
      // .to(".data-box-qj", { width: "100%", duration: 1 }, 8.9)
      .addLabel("qj")

      .to(".moun-box-pa", { opacity: 0.1, duration: 0.5 }, "qj-=0.2")
      .to(".moun-box-qj", { x: 50, y: 550, scale: 1.5, duration: 1.5 }, "qj")
      .to(".nor-qj-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "qj")
      .to(".moun-box-ly", { opacity: 1, duration: 0.4 }, "qj")
      .to(".moun-box-ly", { bottom: 0, duration: 1 }, "qj")
      .to(".nor-ly-moun1", { opacity: 1, duration: 0.3 }, "qj")
      .to(".nor-ly-moun1", { y: 50, duration: 1 }, "qj")
      .to(".address-qj", { x: -100, opacity: 0, duration: 0.5 }, "qj+=0.4")
      .to(
        ".address-ly",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-ly", { width: "100%", duration: 1 });
          }
        },
        "qj+=0.6"
      )
      .to(
        [".moun-box-qj", ".nor-qj-moun1"],
        { opacity: 0, duration: 0.3 },
        "qj+=0.9"
      )
      // .to(".data-box-ly", { width: "100%", duration: 1 }, 11)
      .addLabel("ly")

      .from(
        ".product-ly",
        {
          opacity: 0,
          width: 0,
          duration: 0.2,
          onStart: () => {
            this.featureAudio.play();
          }
        },
        "ly-=0.5"
      )
      .to(".product-ly", { opacity: 0, duration: 0.2 }, "ly")
      .from(
        ".feature-ly",
        {
          opacity: 0,
          y: 200,
          onStart: () => {
            this.$refs.featureLyGif.style.display = "block";
          }
        },
        "ly"
      )
      .to(".feature-ly", { opacity: 0, y: -200 }, "ly+=0.9")

      .to(".moun-box-wy", { opacity: 0.1, duration: 0.5 }, "ly+=0.3")
      .to(
        ".moun-box-ly",
        { x: 50, y: 550, scale: 1.5, duration: 1.5 },
        "ly+=1.5"
      )
      .to(
        ".nor-ly-moun1",
        { x: -80, y: 530, scale: 1.5, duration: 2 },
        "ly+=1.5"
      )
      .to(".moun-box-pa", { opacity: 1, duration: 0.4 }, "ly+=1.5")
      .to(".moun-box-pa", { bottom: 0, duration: 1 }, "ly+=1.5")
      .to(".nor-pa-moun1", { opacity: 1, duration: 0.3 }, "ly+=1.5")
      .to(".nor-pa-moun1", { y: 50, duration: 1 }, "ly+=1.5")
      .to(
        ".address-ly",
        {
          x: -100,
          opacity: 0,
          duration: 0.5
        },
        "ly+=1.9"
      )
      .to(
        ".address-pa",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-pa", { width: "100%", duration: 1 });
          }
        },
        "ly+=2.2"
      )
      .to(
        [".moun-box-ly", ".nor-ly-moun1"],
        { opacity: 0, duration: 0.3 },
        "ly+=2.4"
      )
      // .to(".data-box-pa", { width: "100%", duration: 1 }, 14.1)
      .addLabel("pa")

      .to(".moun-box-ca", { opacity: 0.1, duration: 0.5 }, "pa-=0.2")
      .to(".moun-box-pa", { x: 50, y: 550, scale: 1.5, duration: 1.5 }, "pa")
      .to(".nor-pa-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "pa")
      .to(".moun-box-wy", { opacity: 1, duration: 0.4 }, "pa")
      .to(".moun-box-wy", { bottom: 0, duration: 1 }, "pa")
      .to(".nor-wy-moun1", { opacity: 1, duration: 0.3 }, "pa")
      .to(".nor-wy-moun1", { y: 50, duration: 1 }, "pa")
      .to(".address-pa", { x: -100, opacity: 0, duration: 0.5 }, "pa+=0.4")
      .to(
        ".address-wy",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-wy", { width: "100%", duration: 1 });
          }
        },
        "pa+=0.6"
      )
      .to(
        [".moun-box-pa", ".nor-pa-moun1"],
        { opacity: 0, duration: 0.3 },
        "pa+=0.9"
      )
      // .to(".data-box-wy", { width: "100%", duration: 1 }, 16.2)
      .addLabel("wy")

      .from(
        ".product-wy",
        {
          opacity: 0,
          width: 0,
          duration: 0.2,
          onStart: () => {
            this.featureAudio.play();
          }
        },
        "wy-=0.5"
      )
      .to(".product-wy", { opacity: 0, duration: 0.2 }, "wy")
      .from(
        ".feature-wy",
        {
          opacity: 0,
          y: 200,
          onStart: () => {
            this.$refs.featureWyGif.style.display = "block";
          }
        },
        "wy"
      )
      .to(".feature-wy", { opacity: 0, y: -200 }, "wy+=0.9")

      .to(
        ".moun-box-wy",
        { x: 50, y: 550, scale: 1.5, duration: 1.5 },
        "wy+=1.5"
      )
      .to(
        ".nor-wy-moun1",
        { x: -80, y: 530, scale: 1.5, duration: 2 },
        "wy+=1.5"
      )
      .to(".moun-box-ca", { opacity: 1, duration: 0.4 }, "wy+=1.5")
      .to(".moun-box-ca", { bottom: 0, duration: 1 }, "wy+=1.5")
      .to(".nor-ca-moun1", { opacity: 1, duration: 0.3 }, "wy+=1.5")
      .to(".nor-ca-moun1", { y: 50, duration: 1 }, "wy+=1.5")
      .to(".address-wy", { x: -100, opacity: 0, duration: 0.5 }, "wy+=1.9")
      .to(
        ".address-ca",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-ca", { width: "100%", duration: 1 });
          }
        },
        "wy+=2.2"
      )
      .to(
        [".moun-box-wy", ".nor-wy-moun1"],
        { opacity: 0, duration: 0.3 },
        "wy+=2.4"
      )
      // .to(".data-box-ca", { width: "100%", duration: 1 }, 19.8)
      .addLabel("ca")

      .from(
        ".product-ca",
        {
          opacity: 0,
          width: 0,
          duration: 0.2,
          onStart: () => {
            this.featureAudio.play();
          }
        },
        "ca-=0.5"
      )
      .to(".product-ca", { opacity: 0, duration: 0.2 }, "ca")
      .from(
        ".feature-ca",
        {
          opacity: 0,
          y: 200,
          onStart: () => {
            this.$refs.featureCaGif.style.display = "block";
          }
        },
        "ca"
      )
      .to(".feature-ca", { opacity: 0, y: -200 }, "ca+=0.5")
      .to(
        [".back-btn", ".end-btn"],
        { opacity: 1, duration: 2, display: "block" },
        "ca+=1"
      )
      .to(
        ".end-page",
        {
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            gsap.from(".end-txt", {
              opacity: 0,
              height: 0,
              delay: 0.2,
              duration: 2,
              onComplete: () => {
                if (this.visitedAll) {
                  setTimeout(() => {
                    this.endVisit();
                  }, 2500);
                }
              }
            });
          }
        },
        "ca+=1"
      );

    // tl.play();

    let scrollPage = document.getElementById("scrollPageQt");
    let scrollHeight = scrollPage.scrollHeight;
    let progressHeight = scrollHeight - window.innerHeight;
    let progress, top;
    scrollPage.addEventListener(
      "scroll",
      function() {
        top = scrollPage.scrollTop;
        progress = parseFloat(top / progressHeight);
        // console.log(progress);
        tl.progress(progress);
      },
      false
    );
  },
  methods: {
    hideRoad() {
      this.$emit("hideroad", "qt");
    },
    endVisit() {
      this.$emit("endvisit", "qt");
    },
    controlMusic() {
      this.$emit("playmusic", "qt");
    }
  }
};
</script>
<style lang="less" scoped>
.mountain-page {
  width: 100%;
  height: 100%;
  background-color: #fff;
  // background: url("../assets/img/bg.jpg") no-repeat center;
  // background-size: 100% 100%;
  position: relative;
  .hand {
    width: 89px;
    height: 90px;
    left: 50%;
    margin-left: -20px;
    bottom: 120px;
    z-index: 5;
  }
  .hand-tips {
    width: 191px;
    height: 58px;
    left: 50%;
    margin-left: -80px;
    bottom: 80px;
    z-index: 5;
  }
  .back-btn {
    background-color: rgba(18, 115, 168, 0.75);
  }
  .end-page {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 5;
    .end-txt {
      width: 511px;
      height: 282px;
      top: 102px;
      left: 50%;
      margin-left: -511/2px;
      background: url("../assets/img/end_txt_qt.png") no-repeat top;
      background-size: 100% auto;
    }
    .end-page-bg {
      width: 100%;
      height: 100%;
    }
  }
  .progress-list-box {
    top: 100px;
    right: 60px;
    z-index: 2;
    .icon-road {
      width: 63px;
      height: 64px;
      top: -64 - 23px;
      left: -21px;
    }
    .progress-item {
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-bottom: 16px solid rgba(72, 144, 185, 0.25);
      margin-bottom: 7px;
      &.active {
        border-bottom: 16px solid #4890b9;
        // background-color: #4890b9;
      }
    }
  }
  .mountain {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .address-js {
      width: 102px;
      height: 356px;
      left: 27px;
      top: 25px;
      z-index: 20;
    }
    .icon-gdp {
      width: 172px;
      height: 24px;
      left: 39px;
      bottom: 837px;
    }
    .moun-box-js {
      width: 750px;
      height: 803px;
      right: 0;
      bottom: 0;
      .data-box-js {
        width: 0;
        height: 767px;
        left: 28px;
        top: -44px;
        background: url("../assets/img/data_js.png") no-repeat left top;
        background-size: auto 100%;
        z-index: 5;
      }
      .data-moun-js {
        width: 100%;
        height: 100%;
      }
    }
    .nor-js-moun1 {
      width: 750px;
      height: 894px;
      left: 0;
      bottom: 0;
    }
    .product-cs {
      width: 577px;
      height: 565px;
      top: 86/1334 * 100%;
      left: 50%;
      // margin-top: -565/2 - 50px;
      // margin-left: -577/2px;
      // opacity: 0;
      transform: translateX(-50%);
      z-index: 5;
    }
    .feature-cs {
      width: 710px;
      height: 628px;
      top: 86/1334 * 100%;
      left: 50%;
      margin-left: -355px;
      opacity: 1;
      box-shadow: 5px 5px 50px rgba(0, 0, 0, 0.2);
      z-index: 10;
      .feature-data {
        width: 622px;
        height: 315px;
        top: 210px;
        left: 45px;
        display: none;
      }
    }
    .address-cs {
      width: 99px;
      height: 359px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-cs {
      width: 750px;
      height: 776px;
      left: 0;
      bottom: 160px;
      opacity: 0.1;
      .data-moun-cs {
        width: 100%;
        height: 100%;
      }
      .data-box-cs {
        width: 0;
        height: 742px;
        top: -46px;
        left: 22px;
        background: url("../assets/img/data_cs.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-cs-moun1 {
      width: 750px;
      height: 873px;
      bottom: 80px;
      left: 0;
      opacity: 0;
    }
    .address-kh {
      width: 108px;
      height: 355px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
      z-index: 20;
    }
    .moun-box-kh {
      width: 750px;
      height: 795px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-kh {
        width: 100%;
        height: 100%;
      }
      .data-box-kh {
        width: 0;
        height: 757px;
        top: -42px;
        left: 19px;
        background: url("../assets/img/data_kh.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-kh-moun1 {
      width: 750px;
      height: 841px;
      left: 0;
      bottom: 100px;
      opacity: 0;
    }
    .address-kc {
      width: 107px;
      height: 360px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-kc {
      width: 750px;
      height: 792px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-kc {
        width: 100%;
        height: 100%;
      }
      .data-box-kc {
        width: 0;
        height: 749px;
        top: -37px;
        left: 20px;
        background: url("../assets/img/data_kc.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-kc-moun1 {
      width: 750px;
      height: 760px;
      left: 0;
      bottom: 100px;
      opacity: 0;
    }
    .nor-kc-moun2 {
      width: 750px;
      height: 849px;
      left: 0;
      bottom: 100px;
      opacity: 0;
    }
    .address-qj {
      width: 107px;
      height: 356px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-qj {
      width: 750px;
      height: 774px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-qj {
        width: 100%;
        height: 100%;
      }
      .data-box-qj {
        width: 0;
        height: 734px;
        top: -40px;
        left: 21px;
        background: url("../assets/img/data_qj.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-qj-moun1 {
      width: 750px;
      height: 870px;
      left: 0;
      bottom: 100px;
      opacity: 0;
    }
    .product-ly {
      width: 577px;
      height: 565px;
      top: 86/1334 * 100%;
      left: 50%;
      // margin-top: -565/2 - 50px;
      // margin-left: -577/2px;
      // opacity: 0;
      transform: translateX(-50%);
      z-index: 5;
    }
    .feature-ly {
      width: 710px;
      height: 946px;
      top: 86/1334 * 100%;
      left: 50%;
      margin-left: -355px;
      opacity: 1;
      box-shadow: 5px 5px 50px rgba(0, 0, 0, 0.2);
      z-index: 10;
      .feature-data {
        width: 636px;
        height: 634px;
        top: 125px;
        left: 36px;
        display: none;
      }
    }
    .address-ly {
      width: 107px;
      height: 360px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-ly {
      width: 750px;
      height: 804px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-ly {
        width: 100%;
        height: 100%;
      }
      .data-box-ly {
        width: 0;
        height: 770px;
        top: -46px;
        left: 22px;
        background: url("../assets/img/data_ly.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-ly-moun1 {
      width: 750px;
      height: 864px;
      left: 0;
      bottom: 100px;
      opacity: 0;
    }
    .address-pa {
      width: 103px;
      height: 359px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-pa {
      width: 750px;
      height: 782px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-pa {
        width: 100%;
        height: 100%;
      }
      .data-box-pa {
        width: 0;
        height: 741px;
        top: -39px;
        left: 20px;
        background: url("../assets/img/data_pa.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-pa-moun1 {
      width: 750px;
      height: 879px;
      left: 0;
      bottom: 100px;
      opacity: 0;
    }
    .product-wy {
      width: 577px;
      height: 565px;
      top: 86/1334 * 100%;
      left: 50%;
      // margin-top: -565/2 - 50px;
      // margin-left: -577/2px;
      // opacity: 0;
      transform: translateX(-50%);
      z-index: 5;
    }
    .feature-wy {
      width: 710px;
      height: 961px;
      top: 86/1334 * 100%;
      left: 50%;
      margin-left: -355px;
      opacity: 1;
      box-shadow: 5px 5px 50px rgba(0, 0, 0, 0.2);
      z-index: 10;
      .feature-data {
        width: 523px;
        height: 553px;
        top: 220px;
        left: 92px;
        display: none;
      }
    }
    .address-wy {
      width: 105px;
      height: 359px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-wy {
      width: 750px;
      height: 804px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-wy {
        width: 100%;
        height: 100%;
      }
      .data-box-wy {
        width: 0;
        height: 770px;
        top: -46px;
        left: 19px;
        background: url("../assets/img/data_wy.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-wy-moun1 {
      width: 750px;
      height: 868px;
      left: 0;
      bottom: 100px;
      opacity: 0;
    }
    .address-ca {
      width: 107px;
      height: 358px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-ca {
      width: 750px;
      height: 779px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-ca {
        width: 100%;
        height: 100%;
      }
      .data-box-ca {
        width: 0;
        height: 744px;
        top: -45px;
        left: 20px;
        background: url("../assets/img/data_ca.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-ca-moun1 {
      width: 750px;
      height: 868px;
      left: 0;
      bottom: 100px;
      opacity: 0;
    }
    .product-ca {
      width: 577px;
      height: 565px;
      top: 86/1334 * 100%;
      left: 50%;
      // margin-top: -565/2 - 50px;
      // margin-left: -577/2px;
      // opacity: 0;
      transform: translateX(-50%);
      z-index: 5;
    }
    .feature-ca {
      width: 710px;
      height: 620px;
      top: 86/1334 * 100%;
      left: 50%;
      margin-left: -355px;
      opacity: 1;
      box-shadow: 5px 5px 50px rgba(0, 0, 0, 0.2);
      z-index: 10;
      .feature-data {
        width: 628px;
        height: 376px;
        top: 140px;
        left: 45px;
        display: none;
      }
    }
  }
  .scroll-page {
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    .inner-scroll {
      width: 100%;
      height: 21000px;
    }
  }
}
@keyframes dataAni {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
</style>
